import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiCheckCircle, FiMail, FiMapPin
} from 'react-icons/fi';

const milestones = [
  { year: '2024', title: 'Korpnex Founded', desc: 'Started with a vision to make quality tech education accessible to all college students.' },
  { year: '2024', title: 'First Batch Launched', desc: 'Successfully trained our first batch of students in Full Stack Development.' },
  { year: '2025', title: 'Expanded Programs', desc: 'Added Data Science & AI and Digital Marketing programs based on industry demand.' },
  { year: '2025', title: 'Placement Partnerships', desc: 'Partnered with 20+ companies for internship and placement opportunities.' },
];

const values = [
  { icon: '🎯', title: 'Industry-First Learning', desc: 'Everything we teach is directly applicable to real jobs. No outdated theory.' },
  { icon: '🤝', title: 'Mentorship Driven', desc: 'Every student gets personal attention from experienced industry professionals.' },
  { icon: '🚀', title: 'Placement Focused', desc: 'Our goal is not just to teach but to get you placed in your dream company.' },
  { icon: '💡', title: 'Project Based', desc: 'Learn by building real projects that you can show to employers.' },
  { icon: '📱', title: 'Flexible Learning', desc: 'Access content anytime, anywhere on any device.' },
  { icon: '❤️', title: 'Student Success', desc: 'Your success is our success. We go above and beyond for every student.' },
];

// ── Add your photos inside frontend/public/assets/ folder
// ── Name them exactly as listed below
const galleryPhotos = [
  { src: '/assets/photo1.png', caption: 'Students in a live coding session' },
  { src: '/assets/photo2.png', caption: 'Mentor guiding students on projects' },
  { src: '/assets/photo3.png', caption: 'Team collaboration at Korpnex' },
  { src: '/assets/photo4.png', caption: 'Student presenting their project' },
  { src: '/assets/photo5.png', caption: 'Placement preparation workshop' },
  { src: '/assets/photo6.png', caption: 'Celebrating student success' },
];

export default function AboutPage() {
  return (
    <div style={{ paddingTop: 70 }}>
      <style>{`
        .about-hero { background: linear-gradient(135deg, #0f172a, #1a3a5c); color: white; padding: 80px 24px; text-align: center; }
        .about-hero h1 { font-size: clamp(28px, 5vw, 48px); margin-bottom: 16px; font-family: var(--font-display); }
        .about-hero p { font-size: 18px; color: #94a3b8; max-width: 600px; margin: 0 auto 32px; line-height: 1.8; }
        .about-section { max-width: 1100px; margin: 0 auto; padding: 64px 24px; }
        .about-section h2 { font-size: 32px; font-family: var(--font-display); margin-bottom: 12px; color: var(--dark); }
        .about-section .sub { color: var(--mid); font-size: 16px; margin-bottom: 48px; }
        .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin-bottom: 64px; }
        .stat-card { background: white; border: 1px solid var(--border); border-radius: var(--radius-xl); padding: 28px; text-align: center; box-shadow: var(--shadow-sm); }
        .stat-val { font-size: 36px; font-weight: 800; font-family: var(--font-display); color: var(--primary); margin-bottom: 6px; }
        .stat-lbl { font-size: 14px; color: var(--mid); font-weight: 500; }
        .values-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
        .value-card { background: white; border: 1px solid var(--border); border-radius: var(--radius-xl); padding: 28px; transition: var(--transition); }
        .value-card:hover { border-color: var(--primary); box-shadow: var(--shadow-md); transform: translateY(-3px); }
        .value-icon { font-size: 36px; margin-bottom: 14px; }
        .value-title { font-size: 16px; font-weight: 700; margin-bottom: 8px; color: var(--dark); }
        .value-desc { font-size: 14px; color: var(--mid); line-height: 1.7; }
        .timeline { position: relative; padding-left: 32px; }
        .timeline::before { content: ''; position: absolute; left: 10px; top: 0; bottom: 0; width: 2px; background: var(--border); }
        .timeline-item { position: relative; margin-bottom: 36px; }
        .timeline-dot { position: absolute; left: -28px; top: 4px; width: 16px; height: 16px; border-radius: 50%; background: var(--primary); border: 3px solid white; box-shadow: 0 0 0 2px var(--primary); }
        .timeline-year { font-size: 12px; color: var(--primary); font-weight: 700; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 1px; }
        .timeline-title { font-size: 16px; font-weight: 700; margin-bottom: 6px; color: var(--dark); }
        .timeline-desc { font-size: 14px; color: var(--mid); line-height: 1.7; }
        .about-cta { background: linear-gradient(135deg, var(--primary), #1e40af); color: white; padding: 64px 24px; text-align: center; }
        .about-cta h2 { font-size: 32px; font-family: var(--font-display); margin-bottom: 14px; }
        .about-cta p { font-size: 16px; opacity: 0.85; margin-bottom: 28px; }
        .tc-section { background: var(--bg); }
        .tc-content { max-width: 800px; margin: 0 auto; padding: 64px 24px; }
        .tc-content h2 { font-size: 28px; font-family: var(--font-display); margin-bottom: 8px; }
        .tc-content h3 { font-size: 18px; font-weight: 700; margin: 28px 0 10px; color: var(--dark); }
        .tc-content p { font-size: 14px; color: var(--mid); line-height: 1.9; margin-bottom: 12px; }
        .tc-content ul { padding-left: 20px; }
        .tc-content ul li { font-size: 14px; color: var(--mid); line-height: 1.9; margin-bottom: 6px; }

        /* Gallery */
        .gallery-section { background: #f8fafc; padding: 64px 24px; }
        .gallery-inner { max-width: 1100px; margin: 0 auto; }
        .gallery-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 40px; }
        .gallery-item { position: relative; border-radius: 16px; overflow: hidden; aspect-ratio: 4/3; box-shadow: var(--shadow-md); cursor: pointer; }
        .gallery-item img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.4s ease; display: block; }
        .gallery-item:hover img { transform: scale(1.05); }
        .gallery-caption { position: absolute; bottom: 0; left: 0; right: 0; background: linear-gradient(to top, rgba(0,0,0,0.75), transparent); color: white; padding: 20px 16px 14px; font-size: 13px; font-weight: 500; opacity: 0; transition: opacity 0.3s; }
        .gallery-item:hover .gallery-caption { opacity: 1; }

        @media(max-width:900px) {
          .gallery-grid { grid-template-columns: repeat(2,1fr); }
        }
        @media(max-width:768px) {
          .stats-grid { grid-template-columns: repeat(2,1fr); }
          .values-grid { grid-template-columns: 1fr; }
          .gallery-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      {/* Hero */}
      <div className="about-hero">
        <div style={{ fontSize: 56, marginBottom: 16 }}>🎓</div>
        <h1>About Korpnex</h1>
        <p>
          We are on a mission to bridge the gap between college education
          and industry requirements — one student at a time.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/apply" className="btn btn-accent btn-lg">Apply Now</Link>
          <Link to="/courses" className="btn btn-lg" style={{ background: 'rgba(255,255,255,0.1)', color: 'white', border: '1px solid rgba(255,255,255,0.3)' }}>
            View Courses
          </Link>
        </div>
      </div>

      {/* Stats */}
      <div className="about-section">
        <div className="stats-grid">
          {[
            { v: '500+', l: 'Students Trained' },
            { v: '95%',  l: 'Placement Rate' },
            { v: '20+',  l: 'Hiring Partners' },
            { v: '3',    l: 'Job-Ready Programs' },
          ].map((s, i) => (
            <div key={i} className="stat-card">
              <div className="stat-val">{s.v}</div>
              <div className="stat-lbl">{s.l}</div>
            </div>
          ))}
        </div>

        {/* Who We Are */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center', marginBottom: 64 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
              Who We Are
            </div>
            <h2 style={{ marginBottom: 16 }}>Building India's Next Generation of Tech Talent</h2>
            <p style={{ color: 'var(--mid)', lineHeight: 1.9, marginBottom: 16, fontSize: 15 }}>
              Korpnex is an EdTech platform dedicated to transforming college students and freshers into
              industry-ready professionals. We offer intensive 2-3 month programs that combine
              hands-on projects, mentorship, and placement support.
            </p>
            <p style={{ color: 'var(--mid)', lineHeight: 1.9, marginBottom: 24, fontSize: 15 }}>
              Unlike traditional coaching, we focus on what matters — real skills, real projects,
              and real job opportunities. Our mentors are working professionals who bring
              industry insights directly to your learning.
            </p>
            {['Industry-experienced mentors', 'Project-based curriculum', 'Internship & placement support', 'Lifetime alumni network'].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                <FiCheckCircle size={16} color="var(--success)" />
                <span style={{ fontSize: 14, color: 'var(--dark-3)' }}>{item}</span>
              </div>
            ))}
          </div>
          <div style={{ background: 'linear-gradient(135deg, var(--primary-light), #e0e7ff)', borderRadius: 'var(--radius-xl)', padding: 40, textAlign: 'center' }}>
            <div style={{ fontSize: 80, marginBottom: 20 }}>🚀</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--dark)', marginBottom: 10 }}>Our Vision</div>
            <p style={{ color: 'var(--mid)', fontSize: 14, lineHeight: 1.8 }}>
              To make every college student in India job-ready by providing
              affordable, high-quality tech education with guaranteed placement support.
            </p>
          </div>
        </div>

        {/* Values */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Our Values</div>
          <h2>What Sets Korpnex Apart</h2>
          <p className="sub">We don't just teach — we mentor, support, and place.</p>
        </div>
        <div className="values-grid" style={{ marginBottom: 64 }}>
          {values.map((v, i) => (
            <div key={i} className="value-card">
              <div className="value-icon">{v.icon}</div>
              <div className="value-title">{v.title}</div>
              <div className="value-desc">{v.desc}</div>
            </div>
          ))}
        </div>

        {/* Journey / Roadmap */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'start' }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Our Journey</div>
            <h2 style={{ marginBottom: 32 }}>How We Got Here</h2>
            <div className="timeline">
              {milestones.map((m, i) => (
                <div key={i} className="timeline-item">
                  <div className="timeline-dot" />
                  <div className="timeline-year">{m.year}</div>
                  <div className="timeline-title">{m.title}</div>
                  <div className="timeline-desc">{m.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Student Journey</div>
            <h2 style={{ marginBottom: 32 }}>Your Roadmap to Success</h2>
            {[
              { step: '01', title: 'Apply Online', desc: 'Fill a simple application form. Free to apply, no entrance test.', icon: '📝' },
              { step: '02', title: 'Get Enrolled', desc: 'Admin reviews and approves your application within 24-48 hours.', icon: '✅' },
              { step: '03', title: 'Start Learning', desc: 'Access structured content, live classes, and mentor support.', icon: '📚' },
              { step: '04', title: 'Build Projects', desc: 'Work on real-world projects that build your portfolio.', icon: '💻' },
              { step: '05', title: 'Get Placed', desc: 'Get connected with our hiring partners for internship and jobs.', icon: '🎯' },
            ].map((s, i) => (
              <div key={i} style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>
                  {s.icon}
                </div>
                <div>
                  <div style={{ fontSize: 11, color: 'var(--primary)', fontWeight: 700, marginBottom: 2 }}>STEP {s.step}</div>
                  <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{s.title}</div>
                  <div style={{ fontSize: 13, color: 'var(--mid)', lineHeight: 1.6 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Photo Gallery ── */}
      <div className="gallery-section">
        <div className="gallery-inner">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Life at Korpnex</div>
            <h2 style={{ fontSize: 32, fontFamily: 'var(--font-display)', marginBottom: 8 }}>See What Learning Looks Like</h2>
            <p style={{ color: 'var(--mid)', fontSize: 16 }}>Real students. Real learning. Real results.</p>
          </div>
          <div className="gallery-grid">
            {galleryPhotos.map((photo, i) => (
              <div key={i} className="gallery-item">
                <img
                  src={photo.src}
                  alt={photo.caption}
                  onError={e => {
                    e.target.parentElement.style.background = 'linear-gradient(135deg, #1a56db22, #e8590c22)';
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `
                      <div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:20px;background:linear-gradient(135deg,#f0f4ff,#e0e7ff)">
                        <div style="font-size:48px">${['📸','🎓','💻','🤝','🎯','🏆'][i]}</div>
                        <div style="font-size:13px;color:#64748b;text-align:center;font-weight:500">${photo.caption}</div>
                        <div style="font-size:11px;color:#94a3b8">Add photo: public/assets/photo${i+1}.jpg</div>
                      </div>`;
                  }}
                />
                <div className="gallery-caption">{photo.caption}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="about-cta">
        <h2>Ready to Start Your Journey?</h2>
        <p>Join hundreds of students who have transformed their careers with Korpnex.</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/apply" className="btn btn-lg" style={{ background: 'white', color: 'var(--primary)', fontWeight: 700 }}>
            Apply Now — Free
          </Link>
          <Link to="/contact" className="btn btn-lg" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', border: '1px solid rgba(255,255,255,0.3)' }}>
            Contact Us
          </Link>
        </div>
      </div>

      {/* Terms & Conditions */}
      <div className="tc-section">
        <div className="tc-content">
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Legal</div>
          <h2>Terms & Conditions</h2>
          <p style={{ color: 'var(--mid)', fontSize: 13 }}>Last updated: January 2025</p>
          <h3>1. Acceptance of Terms</h3>
          <p>By accessing and using Korpnex (korpnex.online), you accept and agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>
          <h3>2. Course Enrollment</h3>
          <ul>
            <li>Enrollment is subject to application approval by Korpnex admin team.</li>
            <li>Course fees must be paid as per the payment schedule.</li>
            <li>Korpnex reserves the right to deny enrollment without explanation.</li>
            <li>Course content and schedule may be updated to reflect industry changes.</li>
          </ul>
          <h3>3. Payment & Refund Policy</h3>
          <ul>
            <li>Registration fee of ₹2,000 is non-refundable once paid.</li>
            <li>Remaining course fee refund requests must be made within 7 days of enrollment.</li>
            <li>No refunds will be issued after 7 days of course commencement.</li>
            <li>All payments are processed securely through Razorpay.</li>
          </ul>
          <h3>4. Student Responsibilities</h3>
          <ul>
            <li>Students must complete assignments within given deadlines.</li>
            <li>Regular attendance in live sessions is mandatory.</li>
            <li>Students must maintain respectful behavior in all interactions.</li>
            <li>Course materials are for personal use only and must not be shared.</li>
          </ul>
          <h3>5. Placement Assistance</h3>
          <ul>
            <li>Korpnex provides placement support but does not guarantee job placement.</li>
            <li>Placement opportunities depend on student performance and market conditions.</li>
            <li>Students must actively participate in placement activities.</li>
          </ul>
          <h3>6. Intellectual Property</h3>
          <p>All course content, materials, and resources provided by Korpnex are proprietary. Students may not reproduce, distribute, or share any content without written permission.</p>
          <h3>7. Privacy Policy</h3>
          <p>We collect personal information solely for educational purposes. We do not sell or share your data with third parties. Your information is secured using industry-standard encryption.</p>
          <h3>8. Code of Conduct</h3>
          <ul>
            <li>Treat all mentors, staff and fellow students with respect.</li>
            <li>No harassment, discrimination or inappropriate behavior.</li>
            <li>Academic dishonesty will result in immediate termination.</li>
          </ul>
          <h3>9. Limitation of Liability</h3>
          <p>Korpnex shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services. Our maximum liability is limited to the course fee paid.</p>
          <h3>10. Contact</h3>
          <p>For any questions regarding these terms, contact us at:</p>
          <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '16px 20px', marginTop: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, fontSize: 14 }}>
              <FiMail size={14} color="var(--primary)" />
              <span>hello@korpnex.online</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14 }}>
              <FiMapPin size={14} color="var(--primary)" />
              <span>Bengaluru, Karnataka, India</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}